import {
  DashboardBreaksPanel,
  DashboardCalendarPanel,
  DashboardHoursPanel,
  DashboardSaveBar,
  DashboardSpecialDatesPanel,
  DashboardTimeOffPanel,
} from '@/components/dashboard/DashboardPanels';
import { DashboardHowItWorksLink } from '@/pages/dashboard/DashboardHelpPage';
import { useDashboardSite } from '@/pages/dashboard/DashboardSiteContext';

export default function DashboardSchedulePage() {
  const { isStarterPlan } = useDashboardSite();

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Schedule</h2>
        <p className="text-sm text-muted-foreground">
          Connect Google Calendar or Calendly before enabling in-chat booking on Automation. Hours below control
          which slots the widget suggests.{' '}
          <DashboardHowItWorksLink hash="booking" />
        </p>
      </div>
      {isStarterPlan ? (
        <p className="rounded-md border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground">
          Schedule setup is locked on Starter. Upgrade to Pro to connect a calendar and configure booking hours.
        </p>
      ) : (
        <p className="rounded-md border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground">
          Setup order: connect calendar → choose target → save → on Automation turn on Booking, then Allow booking
          inside chat. Disconnecting calendar turns off in-chat booking (Booking stays only if a fallback link is
          set). Gmail for confirmation emails is separate under Automation.
        </p>
      )}
      <DashboardCalendarPanel />
      <DashboardHoursPanel />
      <DashboardSpecialDatesPanel />
      <DashboardBreaksPanel />
      <DashboardTimeOffPanel />
      <DashboardSaveBar />
    </div>
  );
}
